// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__p-_qa","footer":"ModalError_footer__2u7vy"};